import moment from 'moment';
import $ from 'jquery';

$(_ => {

  const $container = $('#cart-countdown');
  if ($container.length === 0) return;

  const $displayEl = $('#cart-countdown-time');
  const end = moment.utc($displayEl.attr('data-end-time'), moment.ISO_8601);

  let displayVal = '0:00';
  let displayHidden = true;

  const int = window.setInterval(_ => {
    const now = moment();
    const diff = end.diff(now);

    if (diff <= 0) {
      window.clearTimeout(int);
      window.requestAnimationFrame(_ => {
        $container.hide();
        $('#cart-countdown-expiration-message').show();
      });
    } else {

      const duration = moment.duration(diff);
      let mins = String(Math.min(duration.minutes()));
      let secs = String(Math.min(duration.seconds()));

      if (mins.length === 1) mins = '0' + mins;
      if (secs.length === 1) secs = '0' + secs;

      displayVal = mins + ':' + secs;
    }

    window.requestAnimationFrame(_ => {
      if (displayHidden) {
        $displayEl.css('visibility', 'visible');
        displayHidden = false;
      }

      $displayEl.html(displayVal);
    });

  }, 1000);

});